<style lang="scss">
  main {
    height: 100vh;
    max-height: 100vh;
    width: 100%;

    &.dashboard {
      background:
        linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url("/assets/img/marketing/Dashboard.png");
      background-size: 1920px auto;
    }

    &.campaigns {
      background:
        linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url("/assets/img/marketing/Campaigns.png");
      background-size: 1920px auto;
    }

    &.outbox {
      background:
        linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url("/assets/img/marketing/Outbox.png");
      background-size: 1920px auto;
    }

    &.todo {
      background:
        linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url("/assets/img/marketing/ToDos.png");
      background-size: 1920px auto;
    }

    &.calls {
      background:
        linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url("/assets/img/marketing/Calls.png");
      background-size: 1920px auto;
    }
    &.search {
      background:
        linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url("/assets/img/marketing/Search.png");
      background-size: 1920px auto;
    }
    &.reports {
      background:
        linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)),
        url("/assets/img/marketing/Reports.png");
      background-size: 1920px auto;
    }

    flex: 1;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    position: relative;
  }

  .people {
    background-image: url("/assets/img/marketing/lightBlueMask.svg");
    background-size: 100% 100%;
    width: 100%;
    flex: 1;
    display: flex;
  }
</style>

<script>
  import FullPage from "./FullPage.svelte";
  import Overlay from "./Overlay.svelte";
  import { createMarketingPageContext } from "./context.svelte";

  const ctx = createMarketingPageContext();

  const map = {
    "/call": "calls",
    "/calls": "calls",
    "/campaign": "campaign",
    "/campaigns": "campaigns",
    "/contacts": "people",
    "/dashboard": "dashboard",
    "/outbox": "outbox",
    "/outreach": "people",
    "/people": "people",
    "/projects": "people",
    "/reports": "reports",
    "/review": "people",
    "/search": "search",
    "/search-results": "search",
    "/todo": "todo",
    "/upload": "people",
  };

  let cls = $derived(map[ctx.page] || "");
</script>

{#if map[ctx.page] === "people"}
  <FullPage />
{:else}
  <main class={cls}>
    <Overlay />
  </main>
{/if}
